<template>
  <div class="company">
    <div class="coname">
      <img class="banner" src="../assets/co-bg.png" alt="">
       <h1>{{coInfo.coname}}</h1>
    </div>
    <nav>
      <span :class="{'active': tab==='job'}" @click="tab='job'">招聘职位</span>
      <span :class="{'active': tab==='info'}" @click="tab='info'">公司简介</span>
    </nav>
    <div class="tab">
      <div class="job" v-if="tab==='job'">
        <ul>
          <li v-for="(item, index) in jobList" :key="index"><JobItem :job="item" :more="false"/></li>
        </ul>
      </div>
      <div class="info" v-else>
        <h1>{{coInfo.coname}}</h1>
        <p v-html="coInfo.coinfo"><p/>
      </div>
    </div>
    <BackHome />
  </div>
</template>

<script>
// import Icon from '@/components/Icon'
import BackHome from '@/components/BackHome'
import JobItem from '@/components/JobItem';

export default {
  name: 'Company',
  data() {
    return {
      coid: '',
      tab: 'job', // job, info
      jobList: [],
      coInfo: {
        coname: '',
        coinfo: ''
      }
    }
  },
  methods: {
    
  },
  created() {

    console.log(this.$route)
    // 如有需要，使用better-scroll代替overflow
    // 获取coid参数
    this.coInfo.coname = this.$route.params.coname
    
    this.$http.get(`/getjob?project_id=${this.$store.state.projectId}&coname=${this.coInfo.coname}`)
      .then(res=>{
        console.log(res)
        this.jobList = res.data.data.list
        // 此处根据joblist拿到coid并获取公司详情
        if(this.jobList.length > 0) {
          this.coid = this.jobList[0].coid;
          coapi.getCoDetail(this.coid, res => {
            if(res.status === "1") {
              this.coInfo = res.resultbody
            }
          })
        }
      })
  },
  components: {
    BackHome, JobItem
  }
}
</script>

<style lang="scss" scoped>
  .company {
    font-size: 0;
    padding: 16px 16px 0; 
    background: #EDF2FA;
    .coname {
      position: relative;
      height: 360px;
      display: flex;
      justify-content: center;
      align-items: center;
      > h1 {
        width: 80%;
        text-align: center;
        font-size:48px;
        font-weight:600;
        color:#1A3864;
        line-height:66px;
        position: relative;
        z-index: 10;
      }
    }
    .banner {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      border-radius: 8px;
    }
    > nav{
      height: 130px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > span {
        flex: 1;
        font-size:34px;
        font-weight:400;
        color:rgba(153,153,153,1);
        text-align: center;
        position: relative;
        &.active {
          font-weight:bold;
          color:#1A3864;
          &::after {
            content: '';
            width:40px;
            height:4px;
            background:#1A3864;
            border-radius:4px;
            position: absolute;
            bottom: -26px;
            left:0;
            right: 0;
            margin: auto;
          }
        }
        
      }
    }
    .tab {
      height: calc(100vh - 506px);
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        height: 0;
        width: 0;
      }
    }
    .job {
      li {
        border-bottom: 1px solid rgba(229,229,229,.5);
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .info {
      h1 {
        font-size:30px;
        font-weight:600;
        color:rgba(0,0,0,1);
      }
      p {
        margin-top: 32px;
        font-size:28px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:42px;
        white-space: pre-wrap;
      }
      
    }
  }
</style>